<template>
  <div class="author-edit-page scrollable">
    <div class="page-header">
      <h1>{{ $route.meta.title }}</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'authors' }">
          Author
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="edit-form">
      <el-form
          :model="formData"
          status-icon
          :rules="rulesValidate"
          ref="authorEditForm"
          label-width="135px"
          class="demo-ruleForm"
      >

        <el-form-item label="Loaded image">
          <div class="upload-image">
            <img v-if="formData.thumbnail" :src="formData.thumbnail.url" class="preview-image" />
            <i class="el-icon-upload"></i>
            <input
                @change="imgReader"
                type="file"
                accept="image/jpeg,image/png"
                class="input-file"
                title="drop image here">
          </div>
        </el-form-item>

        <el-form-item label="Name" prop="name">
          <el-input
              type="text"
              v-model="formData.name"
              autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item label="Email" prop="email">
          <el-input
              type="text"
              v-model="formData.email"
              autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item label="Title" prop="title">
          <el-input
              type="textarea"
              v-model="formData.title"
              autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item label="Description" prop="description">
          <el-input
              type="textarea"
              v-model="formData.description"
              autocomplete="off"
          ></el-input>
        </el-form-item>

        <div v-for="network in this.formData.social_networks" :key="network.name">
          <el-form-item :label="network.name">
            <el-input v-model="network.url" placeholder="Enter social network URL"></el-input>
          </el-form-item>
        </div>

        <el-form-item>
          <el-button type="primary" @click="submitForm('authorEditForm')"
          >Save
          </el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Message } from 'element-ui'

export default {
  name: 'AuthorEdit',
  data () {
    return {
      urlRequest: '',
      formData: {
        social_networks: []
      },
      rulesValidate: {
        name: [{required: true, message: 'Please input Author name. Name unique', trigger: 'blur'}],
      },
    }
  },
  computed: {
    ...mapGetters({
      author: 'authors/getShowAuthor',
      socialNetworks: 'authors/getSocialNetworks'
    }),
  },

  created () {
    if (this.$route.params.id) {
      this.$store.dispatch('authors/getShowAuthor', this.$route.params.id)
    } else {
      this.$store.dispatch('authors/clearCurrentAuthor')
    }
    this.$store.dispatch('authors/getSocialNetworks')
  },
  watch: {
    author(author) {
      if (author) {
        this.formData = author;
      }
    },
    socialNetworks(networks) {
      if(networks) {
        this.mergeSocialNetworks(networks)
      }
    },
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const formData = new FormData();
          for (let key in this.formData) {
            if(this.formData[key] === null
                ||  (typeof this.formData[key] === 'object' && !(this.formData[key] instanceof File))) {
              continue
            }
            formData.append(key, this.formData[key]);
          }
          this.formData.social_networks.map((item, index) => {
            if (item?.url) {
              formData.append(`social_networks[${index}][name]`, item.name);
              formData.append(`social_networks[${index}][url]`, item.url);
            }
          });

          if (!this.$route.params.id) {
            this.$store.dispatch('authors/createAuthor', formData)
          } else {
            this.$store.dispatch('authors/updateAuthor', {formData: formData, id: this.$route.params.id})
          }
        } else {
          Message({
            message: 'Form not validated',
            type: 'error',
            duration: 5 * 1000,
          })
          console.log('error submit!!')
          return false
        }
      })
    },
    imgReader(e) {
     this.formData.avatar = e.target.files[0];
    },
    mergeSocialNetworks(networks) {
      let existingNames = new Set();
      if(this.author) {
        existingNames = new Set(this.formData.social_networks.map(network => network.name));
      }

      networks.forEach(name => {
        if (!existingNames.has(name)) {
          this.formData.social_networks.push({
            name: name,
            url: ""
          });
        }
      });
    }

  },
}
</script>
<style>
  @import '../../../../assets/scss/authors.scss';
</style>